import script from "./BulletItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulletItem.vue?vue&type=script&setup=true&lang=ts"

import "./BulletItem.vue?vue&type=style&index=0&id=63216c02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63216c02"]])

export default __exports__